import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {LoadingSpinnerService} from "../../services/loading-spinner.service";
import {delay} from "rxjs";
import {User2} from "../../api/models/user-2";
import {AuthService} from "../../services/auth/auth.service";
import {SimpleModalService} from "../../services/simple-modal.service";
import {adminGuard} from "../../guards/admin.guard";

@Component({
    selector: 'app-dashboard',
    imports: [RouterModule, CommonModule],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  isSidebarExpanded = false;
  loadingAjax = false;
  user: User2| null = null
  isAdmin: boolean = false;
  constructor(private loadingService: LoadingSpinnerService,
              private authService: AuthService,
              private router: Router,
              private simpleModalService: SimpleModalService) {
              this.user = this.authService.getAuth();
              this.isAdmin = this.authService.isGranted("ROLE_ADMIN")
  }

  ngOnInit() {
    this.listenToLoading();
  }

  toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }

  /**
   * Listen to the loadingSub property in the LoadingService class. This drives the
   * display of the loading spinner.
   */
  listenToLoading(): void {
    this.loadingService.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.loadingAjax = loading;
      });
  }

  async logout(){
    const result = await this.simpleModalService.openConfirmPromisified("Logout", "Are you sure you want to logout?");
    if(result) {
      await this.authService.logout();
      this.router.navigate(['/login']);
    }
  }

}
